const API_ENV = process.env.API_ENV;

export default {
  valueType: 'UploadImg',
  Type: "upload",
  ocr: false,
  // "vehicleRoadLicenseOCR"
  // drivingLicenseOCRV2
  // upload 上传
  // preview 预览
  otherProps: {
    uploadText: "上传",
    imageUrl: ""
  },
  beforeUploadRules: {
    tips: "照片格式仅支持png、jpg、jpeg,且不能超过2MB大小",
    fileSize: 2,
  },
  UploadProps: {
    accept: "video/mp4",
    action: `https://${API_ENV}.${API_ENV === 'lyt' ? "lieyuntong.cn" : "ailieyun.com"}/api/custom/file/upload`,
    showUploadList: false,
  }
}

